import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-dynamic-variants",
  "use": "foquz-icon-dynamic-variants-usage",
  "viewBox": "0 0 12 12.063",
  "content": "<symbol viewBox=\"0 0 12 12.063\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-dynamic-variants\"><path d=\"M5 8.063h5m-5-3h2m-2 6h3M2 3L1 2m0 0l1-1M1 2h3m6 1l1-1m0 0l-1-1m1 1H8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol